module.exports = __webpack_public_path__ + "img/au.ef935e2.webp";